var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99961 13.4C10.5346 13.4 13.3996 10.535 13.3996 6.99998C13.3996 3.46498 10.5346 0.599976 6.99961 0.599976C3.46461 0.599976 0.599609 3.46498 0.599609 6.99998C0.599609 10.535 3.46461 13.4 6.99961 13.4ZM6.19961 4.59998C6.19961 4.15748 6.55711 3.79998 6.99961 3.79998C7.44211 3.79998 7.79961 4.15748 7.79961 4.59998C7.79961 5.04248 7.44211 5.39998 6.99961 5.39998C6.55711 5.39998 6.19961 5.04248 6.19961 4.59998ZM5.99961 6.19998H7.19961C7.53211 6.19998 7.79961 6.46748 7.79961 6.79998V8.99998H7.99961C8.33211 8.99998 8.59961 9.26748 8.59961 9.59998C8.59961 9.93248 8.33211 10.2 7.99961 10.2H5.99961C5.66711 10.2 5.39961 9.93248 5.39961 9.59998C5.39961 9.26748 5.66711 8.99998 5.99961 8.99998H6.59961V7.39998H5.99961C5.66711 7.39998 5.39961 7.13248 5.39961 6.79998C5.39961 6.46748 5.66711 6.19998 5.99961 6.19998Z",
    fill: "#316ED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.6031414429d1375a352b541a4fcc663b.svg";
export { ForwardRef as ReactComponent };